var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _ProductTitle_instances, initializeTruncation_fn, calculateTruncation_fn, handleResize_fn;
import { Component } from "@theme/component";
class ProductTitle extends Component {
  constructor() {
    super();
    __privateAdd(this, _ProductTitle_instances);
  }
  connectedCallback() {
    super.connectedCallback();
    __privateMethod(this, _ProductTitle_instances, initializeTruncation_fn).call(this);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    window.removeEventListener("resize", __privateMethod(this, _ProductTitle_instances, handleResize_fn));
  }
}
_ProductTitle_instances = new WeakSet();
/**
 * Initialize the title truncation
 */
initializeTruncation_fn = function() {
  if ("ResizeObserver" in window) {
    this.resizeObserver = new ResizeObserver(() => {
      __privateMethod(this, _ProductTitle_instances, calculateTruncation_fn).call(this);
    });
    this.resizeObserver.observe(this);
    __privateMethod(this, _ProductTitle_instances, calculateTruncation_fn).call(this);
  } else {
    window.addEventListener("resize", __privateMethod(this, _ProductTitle_instances, handleResize_fn).bind(this));
    __privateMethod(this, _ProductTitle_instances, calculateTruncation_fn).call(this);
  }
};
/**
 * Calculate truncation for the title
 */
calculateTruncation_fn = function() {
  const textElement = this.refs.text || this.querySelector(".title-text") || this;
  if (!textElement.textContent) return;
  const containerHeight = this.clientHeight;
  const computedStyle = window.getComputedStyle(this);
  const lineHeight = parseFloat(computedStyle.lineHeight);
  const paddingTop = parseFloat(computedStyle.paddingTop);
  const paddingBottom = parseFloat(computedStyle.paddingBottom);
  const availableHeight = containerHeight - paddingTop - paddingBottom;
  const maxLines = Math.max(1, Math.floor(availableHeight / lineHeight));
  textElement.style.display = "-webkit-box";
  textElement.style.webkitBoxOrient = "vertical";
  textElement.style.overflow = "hidden";
  textElement.style.textOverflow = "ellipsis";
  textElement.style.webkitLineClamp = String(maxLines);
};
/**
 * Handle window resize events
 */
handleResize_fn = function() {
  __privateMethod(this, _ProductTitle_instances, calculateTruncation_fn).call(this);
};
if (!customElements.get("product-title")) {
  customElements.define("product-title", ProductTitle);
}
var product_title_truncation_default = ProductTitle;
export {
  product_title_truncation_default as default
};
